import type { ReactElement } from "react";
import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import { ComboboxWithSelectAll } from "app/pages/sales-intelligence/common-components/dropdown/ComboboxWithSelectAll";
import { FormFieldLabel } from "app/pages/sales-intelligence/common-components/form-fields";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import AddListButton from "app/pages/sales-intelligence/modules/leads-search-filters/components/AddListButton/AddListButton";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

import type FindExcludeBySuppressionListFilter from "../../../models/ExcludeBySuppressionListFilter/ExcludeBySuppressionListFilter";
import { FilterContentContainer } from "../styles";

import { DROPDOWN_BUTTON, FIELD_LABEL, DROPDOWN_PLACEHOLDER, SELECT_ALL_LABEL } from "./const";

const ExcludeBySuppressionListFilter = ({
    filter: { options },
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindExcludeBySuppressionListFilter>): ReactElement | null => {
    const items = useMemo(() => {
        return options.map((list) => ({
            id: list.id,
            text: list.name,
        }));
    }, [options]);

    const handleTypeSelection = (selected: number[]) => {
        onFilterUpdate(selected);
    };

    if (!options.length) {
        return (
            <AddListButton
                text={translate("si.lead_gen_filters.add_list.text")}
                disabledTooltip={translate("si.lead_gen_filters.category.exclude.suppression_list.link.tooltip")}
                onClick={() => siNavigator.goToSuppressionManagementPage()}
                hasAccess={salesSettingsHelper.hasSlAccess()}
            />
        );
    }

    return (
        <FilterContentContainer>
            <FormFieldLabel text={translate(FIELD_LABEL)}>
                <ComboboxWithSelectAll
                    onSelectionChange={handleTypeSelection}
                    selectedItems={value}
                    items={items}
                    buttonText={translate(DROPDOWN_BUTTON)}
                    hasSearch
                    searchPlaceHolder={translate(DROPDOWN_PLACEHOLDER)}
                    selectAllLabel={translate(SELECT_ALL_LABEL)}
                />
            </FormFieldLabel>
        </FilterContentContainer>
    );
};

export default ExcludeBySuppressionListFilter;
